module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_vm._v("\n          " + _vm._s(tabitem + ' (' + _vm.ticketList[tabitem].length + ')') + "\n        ")])
  }), 1), _vm._v(" "), (_vm.lAction === 'view') ? _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "id": ("tab-" + n)
      }
    }, [_c('v-layout', {
      staticClass: "pa-2"
    }, [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.ticketList[tabitem].length === 0) ? _c('v-card-text', {
      staticClass: "info--text text-xs-center"
    }, [_vm._v("No Tickets!")]) : _vm._e(), _vm._v(" "), _c('v-expansion-panel', _vm._l((_vm.ticketList[tabitem]), function(ticketItem, i) {
      return _c('v-expansion-panel-content', {
        key: i,
        attrs: {
          "value": i === 0
        },
        on: {
          "input": function($event) {
            return _vm.loadTicket(ticketItem)
          }
        }
      }, [_c('div', {
        attrs: {
          "slot": "header"
        },
        slot: "header"
      }, [_c('v-layout', {
        staticClass: "pb-4",
        attrs: {
          "row": ""
        }
      }, [_c('v-flex', {
        staticClass: "caption",
        attrs: {
          "xs12": ""
        }
      }, [_c('div', {
        staticClass: "pa-1 grey lighten-4 caption black--text",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "left": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s('Ticket #' + ticketItem.ticket_no) + "\n                        ")]), _vm._v(" "), (ticketItem.ticket_status === 'New' || ticketItem.ticket_status === 'Reopened') ? _c('div', {
        staticClass: "pa-1 red lighten-2",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")]) : (ticketItem.ticket_status === 'Assigned') ? _c('div', {
        staticClass: "pa-1 blue lighten-2",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")]) : (ticketItem.ticket_status === 'In Progress') ? _c('div', {
        staticClass: "pa-1 yellow black--text",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")]) : (ticketItem.ticket_status === 'Resolved') ? _c('div', {
        staticClass: "pa-1 success",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")]) : _c('div', {
        staticClass: "pa-1 error",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_status) + "\n                        ")])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        class: _vm.$vuetify.breakpoint.sm ? 'ml-2' : '',
        attrs: {
          "xs9": "",
          "sm9": "",
          "md11": ""
        }
      }, [_c('div', {
        staticClass: "subheading"
      }, [_vm._v("\n                          " + _vm._s(ticketItem.ticket_title) + "\n                        ")]), _vm._v(" "), _c('div', {
        staticClass: "caption grey--text mt-2"
      }, [_c('span', {
        staticClass: "mr-2"
      }, [_vm._v(_vm._s(_vm.handy.formatDateTime(ticketItem.ticket_dt)))])])])], 1)], 1), _vm._v(" "), _c('v-card', {
        attrs: {
          "flat": ""
        }
      }, [_c('v-card-text', {
        staticClass: "pt-2 pb-2"
      }, [_c('div', {
        staticClass: "pb-3"
      }, [_vm._v(_vm._s(ticketItem.ticket_desc))]), _vm._v(" "), _vm._l((ticketItem.details), function(det, d) {
        return _c('v-card', {
          key: d,
          staticClass: "grey lighten-4 mb-1"
        }, [_c('v-card-text', {
          staticClass: "pt-2 pr-2 pb-0 pl-2"
        }, [_c('div', [_c('span', {
          staticClass: "caption grey--text"
        }, [_vm._v(_vm._s(det.ticket_status) + " by " + _vm._s(det.updated_by_temp) + " " + _vm._s(det.ticket_status === 'Assigned' && det.assigned_to ? ' to ' + det.assigned_to : '') + " - " + _vm._s(_vm.handy.formatDateTime(det.updated_dt)))]), _vm._v(" "), _c('div', {
          staticClass: "info--text"
        }, [_vm._v(_vm._s(det.notes) + " ")])])]), _vm._v(" "), _c('v-card-actions', {
          staticClass: "pt-0"
        }, [_c('v-spacer'), _vm._v(" "), (det.user_id && tabitem !== 'all closed') ? _c('v-btn', {
          staticClass: "mt-0",
          attrs: {
            "icon": "",
            "disabled": _vm.beingSaved
          },
          nativeOn: {
            "click": function($event) {
              return _vm.deleteNotes(ticketItem, det, d)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("delete")])], 1) : _vm._e()], 1)], 1)
      }), _vm._v(" "), (ticketItem.ready_for_comment) ? _c('div', [_c('div', [_c('span', {
        staticStyle: {
          "float": "right"
        },
        attrs: {
          "color": "grey"
        }
      }, [_c('v-btn', {
        staticClass: "ma-0",
        attrs: {
          "icon": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.cancelComment(ticketItem)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "hide-details": "",
          "textarea": "",
          "placeholder": "Your comment",
          "rows": "2"
        },
        model: {
          value: (ticketItem.comment.notes),
          callback: function($$v) {
            _vm.$set(ticketItem.comment, "notes", $$v)
          },
          expression: "ticketItem.comment.notes"
        }
      })], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right"
        }
      }, [_c('v-btn', {
        staticClass: "ma-0",
        attrs: {
          "flat": "",
          "color": "accent",
          "disabled": _vm.beingSaved
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.postComment(ticketItem)
          }
        }
      }, [_vm._v("Comment")])], 1)]) : _vm._e(), _vm._v(" "), (!ticketItem.ready_for_comment) ? _c('div', [_c('v-card', [_c('v-card-actions', {
        staticClass: "ma-0 pa-0"
      }, [_c('v-spacer'), _vm._v(" "), (tabitem === 'all open') ? _c('v-btn', {
        staticClass: "pl-3 pr-3",
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareComment(ticketItem)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("comment")])], 1) : _vm._e(), _vm._v(" "), (tabitem === 'all open') ? _c('v-btn', {
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareEdit(ticketItem)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (tabitem === 'all open') ? _c('v-btn', {
        attrs: {
          "icon": "",
          "disabled": _vm.beingSaved
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteItem(ticketItem)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (tabitem === 'all closed') ? _c('v-btn', {
        attrs: {
          "small": "",
          "flat": "",
          "disabled": _vm.beingSaved
        },
        nativeOn: {
          "click": function($event) {
            return _vm.reopenTicket(ticketItem)
          }
        }
      }, [_vm._v("Reopen")]) : _vm._e()], 1)], 1)], 1) : _vm._e()], 2)], 1)], 1)
    }), 1)], 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:65px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 2) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges(_vm.lAction)
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n              " + _vm._s(_vm.handy.startWithUpper(_vm.lAction)) + " Ticket\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "title",
    attrs: {
      "label": "Ticket title",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.ticket.ticket_title),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "ticket_title", $$v)
      },
      expression: "ticket.ticket_title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    staticClass: "mt-2",
    attrs: {
      "label": "Ticket description",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "multi-line": "",
      "rows": "4",
      "maxlength": "1000"
    },
    model: {
      value: (_vm.ticket.ticket_desc),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "ticket_desc", $$v)
      },
      expression: "ticket.ticket_desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-1 subheading",
    attrs: {
      "xs8": "",
      "sm9": ""
    }
  }, [_c('span', [_vm._v("Is it critical?")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.ticket.is_critical ? 'Yes' : 'No',
      "hide-details": ""
    },
    model: {
      value: (_vm.ticket.is_critical),
      callback: function($$v) {
        _vm.$set(_vm.ticket, "is_critical", $$v)
      },
      expression: "ticket.is_critical"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Log")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider')], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 2000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-19cf5847","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Support.vue
// module id = 797
// module chunks = 24